import React, { useEffect, useMemo, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

const TOURS_META = [
  { id: 1, label: "Tura 1", hour: "13:00" },
  { id: 2, label: "Tura 2", hour: "15:00" },
  { id: 3, label: "Tura 3", hour: "17:00" },
  { id: 4, label: "Tura 4", hour: "19:00" },
];

function getTourLabel(tourNumber) {
  const found = TOURS_META.find((t) => Number(t.id) === Number(tourNumber));
  return found ? `${found.label} | ${found.hour}` : `Tura ${tourNumber}`;
}

export default function GalaNoTicketsList({ isToogle }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const loadData = async () => {
      try {
        setLoading(true);
        setError("");

        const [usersSnap, ordersSnap] = await Promise.all([
          getDocs(collection(db, "users2026")),
          getDocs(collection(db, "gala-purchases2026")),
        ]);

        if (cancelled) return;

        const usersRaw = usersSnap.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data(),
        }));

        const flattenedSubUsers = [];

        usersRaw.forEach((acc) => {
          Object.values(acc?.subUsers || {}).forEach((subUser, index) => {
            flattenedSubUsers.push({
              uid: acc.uid,
              acc,
              user: subUser,
              subIndex: index,
            });
          });
        });

        const ordersRaw = ordersSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setUsers(flattenedSubUsers);
        setOrders(ordersRaw);
      } catch (err) {
        console.error(err);
        if (!cancelled) {
          setError("Nie udało się pobrać danych.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      cancelled = true;
    };
  }, []);

  const usersWithoutTickets = useMemo(() => {
    if (!users.length) return [];

    const activeOrderCustomers = new Set(
      orders
        .filter((order) => order?.status !== "canceled")
        .map((order) => order?.customer)
        .filter(Boolean)
    );

    return users
      .filter((entry) => {
        const tours = Array.isArray(entry?.user?.tours) ? entry.user.tours : [];
        return tours.length > 0;
      })
      .filter((entry) => {
        return !activeOrderCustomers.has(entry?.uid);
      })
      .map((entry) => {
        const tours = Array.isArray(entry?.user?.tours) ? entry.user.tours : [];

        return {
          uid: entry.uid,
          displayName: entry?.user?.displayName || "Brak imienia i nazwiska",
          parentName:
            entry?.acc?.parent?.displayName ||
            entry?.acc?.displayName ||
            entry?.acc?.email ||
            "-",
          parentEmail: entry?.acc?.email || "-",
          parentPhone: entry?.acc?.parent?.phone || entry?.acc?.phone || "-",
          tours,
          toursLabel: tours.map(getTourLabel).join(", "),
        };
      })
      .sort((a, b) =>
        String(a.displayName).localeCompare(String(b.displayName), "pl")
      );
  }, [users, orders]);

  return (
    <div
      className={isToogle ? "side-toogle-margin" : "side-margin"}
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        overflowY: "auto",
        gap: "18px",
        paddingTop: "20px",
        paddingBottom: "30px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          display: "flex",
          flexDirection: "column",
          gap: "18px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "24px", color: "rgb(30,30,30)" }}>
            Lista osób bez biletów
          </h2>

          <div style={{ fontSize: "13px", color: "rgb(90,90,90)", fontWeight: "bold" }}>
            {loading ? "Ładowanie..." : `Łącznie: ${usersWithoutTickets.length}`}
          </div>
        </div>

        <div
          style={{
            padding: "12px 14px",
            borderRadius: "8px",
            backgroundColor: "rgba(220,20,60,0.05)",
            border: "1px solid rgba(220,20,60,0.15)",
            fontSize: "12px",
            color: "rgb(60,60,60)",
            lineHeight: "1.6",
          }}
        >
          Pokazani są tylko ci <b>subuserzy</b>, którzy mają przypisaną co najmniej
          jedną turę w <b>tours: []</b> i których konto <b>nie ma żadnego zamówienia</b>
          w <b>gala-purchases2026</b> ze statusem innym niż <b>canceled</b>.
        </div>

        {error ? (
          <div
            style={{
              padding: "14px 16px",
              borderRadius: "8px",
              backgroundColor: "rgba(220,20,60,0.08)",
              border: "1px solid rgba(220,20,60,0.18)",
              color: "#DC143C",
              fontSize: "13px",
              fontWeight: "bold",
            }}
          >
            {error}
          </div>
        ) : null}

        {loading ? (
          <div
            style={{
              width: "100%",
              padding: "30px 20px",
              borderRadius: "8px",
              backgroundColor: "rgb(255,255,255,0.75)",
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px",
              textAlign: "center",
              color: "rgb(80,80,80)",
              fontWeight: "bold",
            }}
          >
            Ładowanie danych...
          </div>
        ) : usersWithoutTickets.length === 0 ? (
          <div
            style={{
              width: "100%",
              padding: "30px 20px",
              borderRadius: "8px",
              backgroundColor: "rgb(255,255,255,0.75)",
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px",
              textAlign: "center",
              color: "rgb(80,80,80)",
              fontWeight: "bold",
            }}
          >
            Wszystkie osoby z przypisanymi turami mają już aktywne zamówienia.
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              overflowX: "auto",
              backgroundColor: "rgb(255,255,255,0.78)",
              borderRadius: "10px",
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px",
            }}
          >
            <table
              style={{
                width: "100%",
                minWidth: "900px",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th style={thStyle}>Uczestnik</th>
                  <th style={thStyle}>UID konta</th>
                  <th style={thStyle}>Rodzic / konto</th>
                  <th style={thStyle}>Mail</th>
                  <th style={thStyle}>Telefon</th>
                  <th style={thStyle}>Tury</th>
                </tr>
              </thead>
              <tbody>
                {usersWithoutTickets.map((row, index) => (
                  <tr
                    key={`${row.uid}_${row.displayName}_${index}`}
                    style={{ borderTop: "1px solid rgba(0,0,0,0.07)" }}
                  >
                    <td style={tdStyle}>{row.displayName}</td>
                    <td style={{ ...tdStyle, fontFamily: "monospace" }}>{row.uid}</td>
                    <td style={tdStyle}>{row.parentName}</td>
                    <td style={tdStyle}>{row.parentEmail}</td>
                    <td style={tdStyle}>{row.parentPhone}</td>
                    <td style={tdStyle}>{row.toursLabel}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const thStyle = {
  textAlign: "left",
  padding: "12px 14px",
  fontSize: "13px",
  color: "rgb(70,70,70)",
  borderBottom: "1px solid rgba(0,0,0,0.08)",
  backgroundColor: "rgba(0,0,0,0.02)",
};

const tdStyle = {
  padding: "12px 14px",
  fontSize: "13px",
  color: "rgb(35,35,35)",
  verticalAlign: "top",
};